import { getField } from "vuex-map-fields";

const genericGetters = (state, getters, rootState, rootGetters) => (getter) => rootGetters[`$_generic_insurance/${getter}`];
const genericState = (state, getters, rootState) => rootState.$_generic_insurance;

export default {
  genericState,
  genericGetters,
  getField,
};
